import { render, staticRenderFns } from "./OfferItem.vue?vue&type=template&id=3f94e5d6"
import script from "./OfferItem.vue?vue&type=script&lang=js"
export * from "./OfferItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f94e5d6')) {
      api.createRecord('3f94e5d6', component.options)
    } else {
      api.reload('3f94e5d6', component.options)
    }
    module.hot.accept("./OfferItem.vue?vue&type=template&id=3f94e5d6", function () {
      api.rerender('3f94e5d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/OfferItem.vue"
export default component.exports